import { combineReducers } from 'redux';
import { auth } from './auth-reducers';
import { app } from './app-reducers';
import { callInfo } from './callInfo-reducer';
import { callHistory } from './callHistory-reducer';
import { contacts } from './contacts-reducer';
import { settings } from './settings-reducers';
import { reducer as tooltip } from 'redux-tooltip';
import { alerts } from './alerts-reducer';
import LoggingService from 's2s-logging-service';


const appReducer = combineReducers({
  app,
  auth,
  alerts,
  callInfo,
  callHistory,
  contacts,
  settings,
  tooltip
  });

  const rootReducer = (state, action) => {
    // This causes store to be wiped when user logs out
    if (action.type === 'LOGOUT') {
      LoggingService.getInstance().debug('INDEX REDUCER --- LOGOUT')

      // NOTE: We are doing this due to an issue where a user does not have an extension. When extensionless-user logs in, they are automatically logged back out and an error is supposed to display. However, because the state is being completely cleared, user never sees this error. Therefore, we decided clear everything EXCEPT the alerts state on logout. - KCN 03/23/2018
      state = {
        alerts : state.alerts
      };
    }

    return appReducer(state, action);
  };

  export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js